import React from 'react';
import BaseSubNavBarDesktop, {
  Props as BaseProps,
} from '../../BaseSubNavBarDesktopInner';
import LargeButtonsWrapper from '../../BaseSubNavBarDesktopInner/legos/LargeButtonsWrapper';
import RightSideButtonWrapper from '../../BaseSubNavBarDesktopInner/legos/RightSideButtonWrapper';
import ProfileSkinsButton from '../_partials/ProfileSkinsButton';
import GroupMemberButton from './_partials/GroupMemberButton';
import GroupMoreMenu from './_partials/GroupMoreMenu';
import SubmitButton from './_partials/SubmitButton';

export interface Props extends BaseProps {}

const GroupProfileSubNavDesktopInner: React.FC<Props> = ({ isSticky }) => {
  return (
    <BaseSubNavBarDesktop
      isSticky={isSticky}
      rightSideContent={
        <>
          <RightSideButtonWrapper>
            <ProfileSkinsButton iconOnly />
          </RightSideButtonWrapper>
          <RightSideButtonWrapper>
            <GroupMoreMenu />
          </RightSideButtonWrapper>
          <LargeButtonsWrapper>
            <RightSideButtonWrapper>
              <GroupMemberButton />
            </RightSideButtonWrapper>
            <RightSideButtonWrapper>
              <SubmitButton />
            </RightSideButtonWrapper>
          </LargeButtonsWrapper>
        </>
      }
    />
  );
};
GroupProfileSubNavDesktopInner.displayName = 'GroupProfileSubNavDesktopInner';

export default GroupProfileSubNavDesktopInner;
